import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import LabelledText from '../App/LabelledText'

export const ICONS = {
  'Solar': 'flaticon-sun',
  'Hydroelectric': 'flaticon-raindrops',
  'Wind': 'flaticon-windmill',
  'Biomass': 'flaticon-biomass',
  'Tidal': 'flaticon-sea',
  'Other': 'flaticon-package',
  'Pumped Storage': 'flaticon-hydraulic-energy'
}

class PowerProject extends Component {
  render () {
    const p = this.props.project
    const federalRiding = p ? p.federalRiding() : null
    const provincialRiding = p ? p.provincialRiding() : null

    return (
      <div className='PowerProject'>
        <h1>{p && p.name}</h1>
        {p &&
          <div>
            <LabelledText
              label={'Primary renewable energy type'}
              text={
                <span>
                  <i className={p.icon} />&nbsp;
                  {p.renewableType} ({p.renewableMW} MW)
                </span>
              }
            />
            {p.owner && <LabelledText label={'Owner'} text={p.owner} />}
            {p.operator && <LabelledText label={'Operator'} text={p.operator} />}
            <LabelledText label={'Location'} text={`${p.city}, ${p.province}`} />
            <LabelledText label={'Latitude / Longitude'} text={`${p.lat}, ${p.lon}`} />
          </div>
        }
        <div>
          {federalRiding &&
            <div>
              <h2>Federal riding</h2>
              <p className='lead'>
                <Link to={federalRiding.URL()}>{federalRiding.name}</Link>
              </p>
            </div>
          }
          {provincialRiding &&
            <div>
              <h2>Provincial riding</h2>
              <p className='lead'>
                <Link to={provincialRiding.URL()}>{provincialRiding.name}</Link>
              </p>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default PowerProject



// WEBPACK FOOTER //
// ./src/components/Projects/PowerProject.js